/* tslint:disable */
import {
  Institutions
} from '../index';

declare var Object: any;
export interface AccountSupportFundInterface {
  "project_name": string;
  "description"?: string;
  "funded_by": string;
  "amount": string;
  "financial_year": string;
  "institution_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  institutions?: Institutions;
}

export class AccountSupportFund implements AccountSupportFundInterface {
  "project_name": string;
  "description": string;
  "funded_by": string;
  "amount": string;
  "financial_year": string;
  "institution_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  institutions: Institutions;
  constructor(data?: AccountSupportFundInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AccountSupportFund`.
   */
  public static getModelName() {
    return "AccountSupportFund";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AccountSupportFund for dynamic purposes.
  **/
  public static factory(data: AccountSupportFundInterface): AccountSupportFund{
    return new AccountSupportFund(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AccountSupportFund',
      plural: 'AccountSupportFunds',
      path: 'AccountSupportFunds',
      properties: {
        "project_name": {
          name: 'project_name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "funded_by": {
          name: 'funded_by',
          type: 'string'
        },
        "amount": {
          name: 'amount',
          type: 'string'
        },
        "financial_year": {
          name: 'financial_year',
          type: 'string'
        },
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        institutions: {
          name: 'institutions',
          type: 'Institutions',
          model: 'Institutions'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/AccountSupportFund.ts